import React, { useState } from "react";
import { motion } from "framer-motion";
import { useDrag } from "react-use-gesture";
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const testimonials = [
  {
    name: "Tanvir Reza",
    role: "CTO at innovative IT",
    image: "https://extendedevolutionarysynthesis.com/wp-content/uploads/2018/02/avatar-1577909_960_720.png",
    text: "Exceptional developer with a deep understanding of modern web technologies. Delivered a high-performance solution tailored to our needs.",
    rating: 5,
  },
  {
    name: "El Semul",
    role: "Founder at Jozzbuzz",
    image: "https://res.cloudinary.com/dqovjmmlx/image/upload/v1740502022/samel_thveyq.jpg",
    text: "Working with this developer was a seamless experience. Professional, innovative, and always ahead of the curve!",
    rating: 5,
  },
  {
    name: "Shamim Rohman",
    role: "CEO at Shamim Production",
    image: "https://scontent.fdac20-1.fna.fbcdn.net/v/t39.30808-6/317087638_2208115176244811_8153927013481515342_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=a5f93a&_nc_eui2=AeE-FGCZBVGXTef07omJxgkpH8veoQa32EYfy96hBrfYRqt2MvZqtOm9qgjupnpfw3qHVmjXgnW-8ww1syYYd3wU&_nc_ohc=g0QZgSAuw6EQ7kNvgFPQKhf&_nc_oc=Adhb9DRUwOsLmbQjTIPKriXVW8SZKVYkURD5Ufu1XKXsF0PRKp-nVX7r1MyYuiThf5o&_nc_zt=23&_nc_ht=scontent.fdac20-1.fna&_nc_gid=Ayfw6kxNZqcxCH7f8ACNcto&oh=00_AYAfEfG1B6vjkuwuTH2NYIhOC8bd-ktV5D91js0KnU5P0Q&oe=67C3C91A",
    text: "Brilliant problem solver! The dedication to efficiency and optimization is truly impressive.",
    rating: 4,
  }
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  const bind = useDrag(({ swipe: [swipeX] }) => {
    if (swipeX < 0) setIndex((prev) => (prev + 1) % testimonials.length);
    if (swipeX > 0) setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  });

  const nextTestimonial = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="flex flex-col items-center py-16  text-gray-200 w-full px-4 md:px-8 lg:px-16">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">Client Testimonials</h2>
      <div className="relative flex justify-center w-full max-w-3xl h-80 md:h-96" {...bind()}>
        {testimonials.map((testimonial, i) => {
          const offset = (i - index + testimonials.length) % testimonials.length;
          return (
            <motion.div
              key={i}
              animate={{
                rotateY: offset * 15,
                x: offset * 90,
                scale: offset === 0 ? 1.0 : .90,
                zIndex: offset === 0 ? 10 : 5,
              }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              className="absolute w-75 md:w-80 lg:w-96 h-80 md:h-96 bg-gradient-to-br from-[#141515] to-[#051323] p-6 rounded-xl shadow-2xl text-center border border-[#867cf92c]"
            >
              <FaQuoteLeft className="text-4xl text-gray-400 opacity-50 mx-auto mb-4" />
              <p className="text-sm md:text-base font-medium mb-4">{testimonial.text}</p>
              <div className="flex justify-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, j) => (
                  <FaStar key={j} className="text-yellow-400 text-lg" />
                ))}
              </div>
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-16 h-16 rounded-full border-2 border-gray-500 shadow-lg mx-auto mb-3"
              />
              <h4 className="text-lg md:text-xl font-semibold">{testimonial.name}</h4>
              <p className="text-gray-400 text-xs md:text-sm">{testimonial.role}</p>
            </motion.div>
          );
        })}
      </div>
      <div className="flex gap-6 mt-8">
        <button onClick={prevTestimonial} className="p-4 bg-gray-700 rounded-full hover:bg-gray-600 transition-all flex items-center justify-center w-12 h-12">
          <FaChevronLeft className="text-white text-2xl" />
        </button>
        <button onClick={nextTestimonial} className="p-4 bg-gray-700 rounded-full hover:bg-gray-600 transition-all flex items-center justify-center w-12 h-12">
          <FaChevronRight className="text-white text-2xl" />
        </button>
      </div>
    </div>
  );
};

export default Testimonials;